import { showErrorToast } from '@amigoapp/doca-react';

export const LINK_EXPIRED_MESSAGE = 'Este link expirou ou já foi utilizado.';
export const NOT_RESCHEDULABLE_MESSAGE = 'Este agendamento não pode mais ser remarcado.';

export const LINK_ERROR_CODES = {
	LINK_INVALID: 'LINK_INVALID',
	ATTENDANCE_NOT_FOUND: 'ATTENDANCE_NOT_FOUND',
	ATTENDANCE_NOT_RESCHEDULABLE: 'ATTENDANCE_NOT_RESCHEDULABLE'
};

export const isLinkInvalid = error => error?.code === LINK_ERROR_CODES.LINK_INVALID;

export const isNotReschedulable = error => [
	LINK_ERROR_CODES.ATTENDANCE_NOT_FOUND,
	LINK_ERROR_CODES.ATTENDANCE_NOT_RESCHEDULABLE
].includes(error?.code);

export const showScheduleLinkErrorToast = (error, scheduleLinkCode) => {
	if (!scheduleLinkCode || !isLinkInvalid(error)) {
		return false;
	}

	showErrorToast(LINK_EXPIRED_MESSAGE);

	return true;
};
